import type { QueryClient } from '@tanstack/react-query';
import { cardQueryRoot, summaryQueryRoot } from '../../../../shared/api/index.js';
import { bankQueries } from '../queries/bank-queries.js';

export const refreshBankAndCards = async (queryClient: QueryClient): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: bankQueries.all() }),
    queryClient.invalidateQueries({ queryKey: cardQueryRoot.lists() }),
    queryClient.invalidateQueries({ queryKey: summaryQueryRoot.all() }),
  ]);
};
